import React, { useRef, useState } from 'react';
import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import NestedRows from './NestedRows';
import { checkDynamicValidation, checkHasError, checkHasErrorInDynamic, generateEmptyRow, makeObjForRow, setFieldsInColumns, validateAllRows } from './utils/utils';
import { cloneDeep, merge } from 'lodash';
import { Add } from '@mui/icons-material';
import NestedColumns from './NestedColumns';
import { showToast } from 'services/utils';
import { useNavigate } from 'react-router';
import AlertOnBackNavigation from '../Components/AlertOnBackNavigation';
import { hasNonEmptyObject } from '../services';


const CustomeNestedTable = ({ data, userData }) => {

    const { columns, rows, config } = data;

    let defaultConfig = {
        backNavigationAlert: true,
        // onDelete: {
        //     before: false,
        //     after: false,
        // },
        onDelete: false,
        // onSubmit: false,
        // addRow: false,
        // addRow: true,
        addRow: {
            isVisible: true,
            isActive: true,
        },
        onSubmit: false,
        isId: true,
        // onSubmit: {
        //     checkESign: true,
        //     // type: "row",
        //     type: "table",
        //     handler: handleSubmit,
        //     checkValidation: true,
        //     isVisible : true,
        //     isActive : true
        //     // before : false,
        //     // after : false
        //     // before : {
        //     //     checkValidation : true,
        //     //     handler : (openFn) => { openFn() }
        //     // }
        // },
        onESign: false,
        // onESign: {
        //     before: {
        //         checkValidation: true,
        //         handler: (handleModelOpen) => {
        //             handleModelOpen()
        //         }
        //     },
        //     // before: false,
        //     // afterESign: false,
        // },
        // validation: {
        //     beforeValidation: false,
        //     afterValidation: false,
        // },
        isDayOff: {
            uniqueName: false,
            isCheck: false,
        },
        // isStatic: true,
        isViewMode: false,
        multipleESign: false,
        // multipleESign: {
        //     format: ["first", "second"],
        //     // start : "second"
        //     start: 0
        // },
        // renderOptions : {
        //     specific : "rows", // all, rows, columns
        //     type : "single", // single
        // }
        // actions: [
        //     {
        //         tooltip : "View document",
        //         name: "view",
        //         icon: <Eye/>,
        //         color: "error",
        //         onClick: () => { },
        //         isVisible : false,
        //         isActive : true
        //     }
        // ],
        actions: false,
        renderOptions: false,
        dependencyFields: false,
        // dependencyFields: {
        //     endTime: {
        //         type: 'all',
        //         // effectOn: ["downTimeDuration"],
        //         // handler: (data) => { },
        //         handler: (data) => {
        //             /*
        //                 perforn any operation and return final value.
        //                 make sure the return value is same as column type
        //             */
        //             return ({
        //                 downTimeDuration: "18 : 20"
        //             })
        //         }
        //     }
        // },
        title: false,
        // title: {
        //     defaultTableName: "testTable",
        //     name: "Test Table",
        //     isVisible: true,
        // },
        chip: {
            // uniqueName: {
            //     color: "",
            //     varient: "",
            //     label: "",
            //     onClick: () => { }
            // },
            // reviewedBy: generateChipConfig
            // (data) => {
            //     /*
            //         clog data = {
            //             row,
            //             column,
            //         }
            //     */
            // }
        },
        navLink: false,
        // navLink: {
        //     breakdownReason: (data) => {
        //         return ({
        //             id : "684d37f7e7eb7998d2cd8b89"
        //         })
        //     }
        // },
        onScroll: false,
        dynamicOptions: false,
        // dynamicOptions: {
        //   //  uniqueName : [ ...options ],
        //   machineName: ["machine-11", "machine-22", "machine-33", "machine-44"],
        //   machineName: {
        //     isUnique: true,
        //     options: ["machine-11", "machine-22", "machine-33", "machine-44"]
        //   },
        // }
        dynamicOptionsByRows: false,
        modifyData: false,
        // modifyData: {
        //   select: {
        //     type: "row",
        //     handler: (data, allData) => {
        //       const { row } = data
        //       if (row?.select) {
        //         allData?.columns?.forEach((col) => {
        //           if (col.uniqueName === "quantity") {
        //             col.isReadOnly = false
        //           }
        //         })
        //       } else if (!row?.select) {
        //         allData?.columns?.forEach((col) => {
        //           if (col.uniqueName === "quantity") {
        //             col.isReadOnly = true
        //           }
        //         })
        //       }
        //       return ({
        //         quantity: true,
        //       })
        //     }
        //   }
        // },
    };

    defaultConfig = merge(defaultConfig, { ...config, userData });

    const [_, forceUpdate] = useState({});
    const navigate = useNavigate();
    const render = () => forceUpdate({})
    const ref = useRef()

    const commonStyle = {
        tableCell: {
            textAlign: 'center',
            minWidth: '300px',
            // maxWidth: '300px',
            // overflowX: 'auto',
            height: '100%',
            padding: "0px",
            py: "5px",
            px: "10px",
            // border : '1px solid red'
        },
        tableRow: {
            height: '100%',
            '&:not(:last-child)': {
                borderBottom: '1px solid #e0e0e0',
            },
            padding: "0px"
        }
    };

    const helperRef = useRef({
        dynamicTypeRef: Array.from({ length: rows?.length }, () => ({})),
        trackChanges: Array.from({ length: rows?.length }, () => ({})),
        optionsUniqueness: {
            availableOptions: {},
            rowsOptions: Array.from({ length: rows?.length }, () => ({})),
        },
        rowByOptions: Array.from({ length: rows?.length }, () => {
            const obj = {}
            makeObjForRow(columns, obj)
            return obj
        }),
        dynamicReadableRef: Array.from({ length: rows?.length }, () => ({})),
        dynamicOptionsRef: Array.from({ length: rows?.length }, () => ({})),
        uniqueOptionByRow: Array.from({ length: rows?.length }, () => ({})),
    })

    const rowsErrorRef = useRef({
        dynamicError: {
            data: Array.from({ length: rows?.length }, () => ({})),
            error: Array.from({ length: rows?.length }, () => ({}))
        },
        staticErrors: []
    })

    const renderRef = useRef({
        allTable: () => { },
        renderRows: {
            allRows: render,
            rows: []
        }
    })

    const handleSubmit = () => {
        let errors = {};
        let hasError = false
        if (
            defaultConfig?.onSubmit !== false &&
            defaultConfig?.onSubmit?.checkValidation === true
        ) {
            errors = validateAllRows(columns, rows)
            rowsErrorRef.current.staticErrors = errors;

            const dynamicError = checkDynamicValidation(rowsErrorRef.current?.dynamicError?.data)
            rowsErrorRef.current.dynamicError.error = dynamicError
            hasError = checkHasError(errors)
            if (!hasError) {
                hasError = checkHasErrorInDynamic(dynamicError)
            }
        }
        if (hasError) {
            renderRef.current.renderRows.allRows();
            showToast("Error in table inputs ! nested", false);
            return false;
        }

        const cloneRows = cloneDeep(rows)
        const cloneTrackChanges = cloneDeep(helperRef.current?.trackChanges)

        defaultConfig?.onSubmit?.handler &&
            defaultConfig?.onSubmit?.handler(
                cloneRows,
                cloneTrackChanges
            );

        helperRef.current.trackChanges = Array.from({ length: rows?.length }, () => ({}))

        return {
            rows: cloneRows,
            trackChanges: cloneTrackChanges,
        };
    };

    const handleAddNewRow = () => {

        const addRowByOptioinHelper = () => {
            const obj = {}
            makeObjForRow(columns, obj)
            return obj
        }

        const newRow = generateEmptyRow(columns)
        helperRef.current.dynamicTypeRef.push({})
        helperRef.current.trackChanges.push({});
        helperRef.current.rowByOptions.push(addRowByOptioinHelper());
        helperRef.current.uniqueOptionByRow.push({});
        rows.push(newRow)
        rowsErrorRef.current.dynamicError.data.push({})
        rowsErrorRef.current.dynamicError.error.push({})
        render()

        if (ref.current?.scrollHeight) {
            setTimeout(() => {
                ref.current.scrollTop = ref.current.scrollHeight;
            }, 0);
        }
    }

    if (!!defaultConfig?.dynamicOptions) {
        Object.keys(defaultConfig?.dynamicOptions).forEach((ky) => {
            setFieldsInColumns("options", defaultConfig?.dynamicOptions?.[ky], ky, columns)
        })
    }

    if (rows?.length === 0) {
        handleAddNewRow()
    }

    const handlerCancel = () => {
        navigate(-1);
    };

    const finalConfig = {
        ...defaultConfig,
        ...helperRef.current,
        renderRows: renderRef.current.renderRows,
        columns,
        rows,
    }

    data.config["GLOBAL_CONFIG"] = {

        SUBMIT_HANDLER: handleSubmit,
        config: finalConfig,
        REF: ref
    }

    if (!!defaultConfig?.getTableInfo && (typeof defaultConfig?.getTableInfo === "function")) {
        defaultConfig?.getTableInfo(
            { finalConfig }
        )
    }

    const { wrapperUtils = {}, syncing = {} } = finalConfig?.wrapperConfig ?? { wrapperUtils: {}, syncing: {} }

    return (
        <Box>

            {/* {
                // !defaultConfig?.wrapperSupport && (defaultConfig?.backNavigationAlert) && (
                !defaultConfig?.wrapperSupport && (
                    <AlertOnBackNavigation
                        getModifyStatus={() => {
                            return hasNonEmptyObject(helperRef.current?.trackChanges)
                        }}
                    />
                )
            } */}

            <TableContainer
                component={Paper}
                sx={{ maxHeight: "80vh" }}
                ref={ref}
            >
                <Table size="small" stickyHeader>
                    <TableHead
                        sx={{
                            position: "sticky",
                            top: "0",
                            bgcolor: "#fff",
                            zIndex: 1000,
                        }}
                    >
                        <NestedColumns
                            columns={columns}
                            commonStyle={commonStyle}
                            config={{
                                ...defaultConfig,
                            }}
                        />
                    </TableHead>
                    <TableBody>
                        <NestedRows
                            rows={rows}
                            columns={columns}
                            commonStyle={commonStyle}
                            config={finalConfig}
                            errorRef={rowsErrorRef}
                        />
                    </TableBody>
                </Table>
            </TableContainer>

            {!defaultConfig?.isViewMode ? (
                <Box
                    sx={{
                        margin: "20px 0px",
                        display: "flex",
                        justifyContent: !!defaultConfig?.addRow?.isVisible
                            ? "space-between"
                            : "end",
                        gap: "10px",
                        width: "100%",
                    }}
                >
                    {!!defaultConfig?.addRow !== false &&
                        defaultConfig?.addRow?.isVisible && (
                            <Button
                                variant="contained"
                                startIcon={<Add />}
                                onClick={handleAddNewRow}
                                disabled={!!!defaultConfig?.addRow?.isActive}
                            >
                                Add
                            </Button>
                        )}

                    {(!!defaultConfig?.wrapperSupport ? !syncing?.submits : true) && (
                        <Box
                            sx={{
                                display: "flex",
                                gap: "20px",
                            }}
                        >
                            {!!defaultConfig?.onCancel !== false &&
                                !!defaultConfig?.onCancel?.isVisible && (
                                    <Button
                                        variant="contained"
                                        color="error"
                                        disabled={!defaultConfig?.onCancel?.isActive ?? false}
                                        onClick={
                                            !!defaultConfig?.onCancel?.handler
                                                ? defaultConfig?.onCancel?.handler
                                                : handlerCancel
                                        }
                                    >
                                        Cancel
                                    </Button>
                                )}
                            {defaultConfig?.onSubmit !== false &&
                                defaultConfig?.onSubmit?.isVisible &&
                                defaultConfig?.onSubmit?.type === "table" ? (
                                <Button
                                    disabled={!defaultConfig?.onSubmit?.isActive}
                                    variant="contained"
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                            ) : null}
                        </Box>
                    )}
                </Box>
            ) : null}
        </Box>

    );
};

export default CustomeNestedTable;